import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4827_71887)">
      <path
        d="M60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5685 60 60 46.5685 60 30Z"
        fill="url(#paint0_radial_4827_71887)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_4827_71887"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.9752 14.6145) scale(45.1744)"
      >
        <stop offset="0.0677083" stopColor="white" />
        <stop offset="0.25" stopColor="#F0F0F0" />
        <stop offset="0.473958" stopColor="#F3F3F3" />
        <stop offset="0.880208" stopColor="#ADADAD" />
        <stop offset="1" stopColor="#CCCCCC" />
      </radialGradient>
      <clipPath id="clip0_4827_71887">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
